import _taggedTemplateLiteral from "@babel/runtime/helpers/esm/taggedTemplateLiteral";
var _templateObject;
import styled from 'styled-components';
import Text from '@magalu/stereo-ui/atoms/Text';
export var StrikeText = styled(Text)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  text-decoration: line-through;\n"])));